"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const Pagination_1 = __importDefault(require("@Components/Pagination"));
const ResultsPerPage_1 = require("@Components/ResultsPerPage");
const PaginationAndLimit = (props) => {
    const { count = 0, limit = 10, paginationInfo, onLimitChange, onPageChange } = props;
    const showPagination = count > limit;
    return (react_1.default.createElement("div", { "data-testid": 'pagination-controls' },
        react_1.default.createElement("section", { className: 'pagination-controls' },
            react_1.default.createElement("div", { className: 'pagination-controls-left' }, showPagination && (react_1.default.createElement(Pagination_1.default, { limit: limit, paginationPages: paginationInfo, onChange: onPageChange }))),
            react_1.default.createElement("div", { className: 'pagination-controls-right' }, onLimitChange && (react_1.default.createElement(ResultsPerPage_1.ResultsPerPage, { limit: limit, buttonValues: [10, 25, 50, 100], onChange: onLimitChange }))))));
};
exports.default = PaginationAndLimit;
